export const shopifyProductStructuredDataMixin = {
    computed: {
        product_structured_data: function () {
            var self = this;
            
            if(!this.product){
                return;
            }
            var title = this.product.title;
            if (title && title.length > 150) {
                title = title.slice(0, 150);
            }
            
            title = this.processStructuredDataText(title);
            
            var description = this.product.description || title;
            description = this.processStructuredDataText(description);
            
            var data = {
                '@context': 'https://schema.org/',
                '@type': 'Product',
                'identifier': {
                    "@type": "PropertyValue",
                    propertyID: 'Shopify ID',
                    value: this.product.id.toString()
                },
                name: title,
//                aggregateRating: {
//                    '@type': 'AggregateRating',
//                    ratingValue: 0,
//                    reviewCount: 0
//                }
            };
            
            if(this.product.search_categories && this.product.search_categories.length){
                data.category = this.product.search_categories.join(' > ');
            }
            
            data.description = description;
            
            if (this.product.profile_url) {
                data.url = this.product.profile_url;
            }

            var images = this.product.images.map(function (image) {
                return image.src;
            });
            if (images.length) {
                data.image = images.slice(0, 5);
            }
            if (this.product.tags && this.product.tags.length) {
                var keywords = this.product.tags.map(function(tag){
                    return self.processStructuredDataText(tag).trim();
                });
                data.keywords = keywords;
            }
            if (this.product.variants && this.product.variants.length) {
                var variant = this.product.variants[0];
                if (variant.sku) {
                    data.sku = variant.sku;
                }
            }

            var offers = {
                '@type': 'Offer',
                url: this.product_url,
                priceCurrency: 'USD',
                price: this.product.unit_price / 100,
                availability: 'https://schema.org/InStock',

            };
            
            var store = this.product.shop;
            if (store) {
                
                if(store.domain && this.product.handle){
                    var base_url = 'https://' + store.domain;
                    var product_url = base_url + '/products/' + this.product.handle;
                    data.sameAs = [product_url];
                }                
                
                var seller = {
                    '@type': 'Organization',
                    name: store.name,
                    url: store.profile_url,
                };
                if (store.logo) {
                    seller.logo = store.logo;
                }
                var address = {
                    '@type': 'PostalAddress'
                };
                if (store.city) {
                    address.addressLocality = store.city;
                }
                if (store.province) {
                    address.addressRegion = store.province;
                }
                if (store.country) {
                    address.addressCountry = store.country;
                }
                seller.location = address;
                offers.seller = seller;
            }
            data.offers = offers;
            return data;
        },
    },
    methods: {
        processStructuredDataText: function(text){
            if(typeof text === 'string'){
                text = text.replace(/"/g, '\''); //replace double quotes with single
                text = text.replace(/\//g, ' '); //replace forward slashes with a space
                text = text.replace(/[\\\/\"]/g, ''); //remove slashes and double quotes
            }
            return text;
        }
    }
}


// WEBPACK FOOTER //
// ./resources/views/rd/assets/js/v2/mixins/shopify/shopifyProductStructuredDataMixin.js